export const ADC_DEVICE_TYPE_CODES = {
  PARTITION: 18,
} as const;

export const ADC_DEVICE_STATUS_CODES = {
  REMOVED: 1,
} as const;
